export function fmtInventoryStatus(value) {
    try {
      return value.InventoryStatus === 'DISABLED'?value.InventoryStatus:value.InventoryFrequency.toUpperCase();
    } catch {
      return "";
    }
}
